import { render, staticRenderFns } from "./express-detail-modal.vue?vue&type=template&id=03cc67e4&scoped=true&"
import script from "./express-detail-modal.vue?vue&type=script&lang=js&"
export * from "./express-detail-modal.vue?vue&type=script&lang=js&"
import style0 from "./express-detail-modal.vue?vue&type=style&index=0&id=03cc67e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc67e4",
  null
  
)

export default component.exports